<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';

	let { imgSrc, text } = $props();
</script>

<div>
	<Image class="shadow-[8px_16px_25px_-6px_#9f9f9f]" src={imgSrc} />
	{#if text}
		<p
			class="
     mt-5 font-bold
     {text === 'YES' ? 'text-indow-green!' : 'text-indow-red!'}"
		>
			{text}
		</p>
	{/if}
</div>
